
export function convertArrayFilterToLabel (filterValue, array) {
  let label = ''
  if (filterValue !== undefined && filterValue !== '') {
    array.map(function (elem) {
      if (elem.value === filterValue) {
        label = elem.label
      }
    })
  }
  return label
}

export function convertDateToLabel (startDate, endDate, today) {
  let label = ''

  if (startDate && endDate) {
    if (startDate === today) {
      label = 'de hoje'
    } else {
      label = label.concat('de ' + startDate)
      label = label.concat(' à ' + endDate)
    }
  }

  return label
}
